import { createSlotRecipe } from './runtime';

const fieldConfig = {"name":"field","slots":["root","labelRow","label","required","help","error","foot","counter"],"defaultVariants":{"inline":false},"variantMap":{"inline":["false","true"]}}

export const field = /* @__PURE__ */ createSlotRecipe(fieldConfig)